// extracted by mini-css-extract-plugin
export var discard = "_2x-3";
export var muiTooltipTooltip = "_2x-5";
export var notificationBar = "_2x-2";
export var saveButtonHoverSlotWrapper = "_2x-4";
export var show = "_2x-1";
export var spacer = "_2x-0";